import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  section: {
    paddingHorizontal: 16,
  },
  sectionTitle: {
    fontWeight: '700',
    marginBottom: 12,
    color: '#111827',
  },
  fieldWrapper: {
    marginBottom: 16,
  },
  fieldLabel: {
    fontSize: 14,
    color: '#374151',
    marginBottom: 6,
    marginTop: 5,
  },

  input: {
    borderWidth: 1,
    borderColor: '#D1D5DB',
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 0,
    minHeight: 48,
    fontSize: 13,
    color: '#111827',
    backgroundColor: '#FFF',
    textAlignVertical: 'center',
    includeFontPadding: false,
  },
  inputError: {
    borderColor: '#900B09',
  },
  errorText: {
    fontSize: 14,
    color: '#900B09',
    fontWeight: '400',
    marginTop: 4,
  },
  addPhoneBtn: {
    marginTop: 3,
    borderWidth: 1,
    borderColor: '#767676',
    borderRadius: 24,
    paddingVertical: 10,
    paddingHorizontal: 20,
    minHeight: 48,
    alignSelf: 'flex-start',
    flexDirection: 'row',
    alignItems: 'center',
    color: '#1E1E1E',
    gap: 6,
  },
  addPhoneBtnText: {
    fontSize: 14,
    color: '#1E1E1E',
  },
  plusIcon: {
    color: '#1E1E1E',
    fontSize: 14,
  },
  addPhoneBtnContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});
